import { Button, Flex, useMediaQuery } from "@wayflyer/flyui";
import type { UseUploadManagerReturn } from "@wayflyer/flyui";
import type {
  BankAccountGroupSchema,
  BankConnectionSchema,
  LogoLoadingState,
  UngroupedStatementSchema,
} from "bankconnect";
import { useIntl } from "react-intl";

import { AddStatementsButton } from "../bank-statements/add-statements-button";
import { BankAccountsList } from "../accounts-list/accounts-list";
import { MESSAGES } from "../message-definitions";
import type { SelectedAccount } from "../utils";

import type { BankStatementUpload } from "../../hooks/use-bank-accounts-upload-manager";

type BankAccountsFilledStateProps = {
  accountGroups: BankAccountGroupSchema[];
  ungroupedConnections: BankConnectionSchema[];
  ungroupedStatements: UngroupedStatementSchema[];
  logoLoadingStates: LogoLoadingState;
  requiredStatementMonths: number;
  onSelectAccount: (account: SelectedAccount) => void;
  onSelectGroup: (group: BankAccountGroupSchema) => void;
  onSelectUnmatchedStatements: () => void;
  onOpenConnectModal: () => void;
  onFilesAdded: UseUploadManagerReturn<BankStatementUpload>["onFilesAdded"];
  isStatementsFullScreenDropzoneEnabled: boolean;
};

export const BankAccountsFilledState = ({
  accountGroups,
  ungroupedConnections,
  ungroupedStatements,
  logoLoadingStates,
  requiredStatementMonths,
  onSelectAccount,
  onSelectGroup,
  onSelectUnmatchedStatements,
  onOpenConnectModal,
  onFilesAdded,
  isStatementsFullScreenDropzoneEnabled,
}: BankAccountsFilledStateProps) => {
  const intl = useIntl();
  const query = useMediaQuery();
  const isMobile = query("sm").windowLte;

  return (
    <Flex direction="column" gap="10">
      <Flex direction={isMobile ? "column" : "row"} gap="2">
        <Button variant="Secondary" fullWidth={isMobile} onClick={onOpenConnectModal}>
          {intl.formatMessage(MESSAGES.addAccountInstantly)}
        </Button>
        <AddStatementsButton
          onFilesAdded={onFilesAdded}
          fullWidth={isMobile}
          fullScreenDropzone={isStatementsFullScreenDropzoneEnabled}
        />
      </Flex>

      <BankAccountsList
        accountGroups={accountGroups}
        ungroupedConnections={ungroupedConnections}
        ungroupedStatements={ungroupedStatements}
        logoLoadingStates={logoLoadingStates}
        requiredStatementMonths={requiredStatementMonths}
        onSelectAccount={onSelectAccount}
        onSelectGroup={onSelectGroup}
        onSelectUnmatchedStatements={onSelectUnmatchedStatements}
      />
    </Flex>
  );
};
